import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { HubSpotObjectDataset } from 'app/model/dataset/hub-spot.dataset';
import { TabularCopySource } from './tabular-type.copysource';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.hubspot.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(HubSpotObjectDataset) }
})
export class HubSpotCopySource extends TabularCopySource {
}
